import store, {
	APIDataSuccess,
	APIDataError,
    APIGenresSuccess,
    APIPlatformSuccess,
} from "./Store";

const state = store.getState();

const method   = state.API.method;
const headers  = state.API.headers;
const url 	   = state.API.url;

const options = {
    method : method,
    headers : headers,
}

function getGenresList(data){
    let arr = ['all'];

    data.forEach((item)=>{
        if(!arr.includes(item.genre)){
            arr.push(item.genre);
        }
    })

    return arr;
}

function getPlatformList(data){
    let arr = ['all'];

    data.forEach((item)=>{
        if(!arr.includes(item.platform)){
            arr.push(item.platform);
        }
    })

    return arr;
}


export const dataFetching = async () => {
    const fetchData = await fetch(url,options)
                      .then((response)=>response.json())
                      .then((response) => {
                      	store.dispatch(APIDataSuccess(response));

                        const genreList = getGenresList(response);
                        store.dispatch(APIGenresSuccess(genreList));

                        const platformList = getPlatformList(response);
                        store.dispatch(APIPlatformSuccess(platformList));
                      })
                      .catch((err) => {
                      	store.dispatch(APIDataSuccess(err));
                      });
}
